'use strict';

module.exports = {
  eventDataKeys: ['initial', 'delta', 'final']
};